module.exports = __webpack_public_path__ + "img/GOODLIFE FITNESS COED.f7b7269f.png";